<template>
  <div class="d-flex justify-space-between align-center">
    <h1 class="d-flex align-center primaryColor--text">
      <v-icon color="primaryColor white--text" class="mr-2">{{ icon }}</v-icon>
      {{ title }}
      <slot name="title"></slot>
    </h1>
    <div class="action">
      <slot name="action"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "SHeader",
  props: {
    icon: {
      type: String,
    },
    title: {
      type: String,
    },
  },
};
</script>

<style></style>
